import { FieldValues, useController, UseControllerProps } from 'react-hook-form'

import CheckboxInput, { CheckboxInputProps } from './CheckboxInput'

type CheckboxInputControllerProps<T extends FieldValues> = UseControllerProps<T> &
  Pick<CheckboxInputProps, 'className' | 'classes' | 'disabled' | 'label' | 'name' | 'readOnly'>

export default function CheckboxInputController<T extends FieldValues>(props: CheckboxInputControllerProps<T>) {
  const { control, label, name, ...rest } = props
  const { field } = useController({ name, control })

  return (
    <CheckboxInput
      {...rest}
      label={label}
      name={field.name}
      onChange={(e) => field.onChange(e.target.checked)}
      checked={!!field.value}
    />
  )
}
